import { v4 as uuidv4 } from 'uuid';
export class Messaging {

    type:string;
    label:string;
    templates:string[];

}